export default __webpack_public_path__ + "static/media/AnimationLargeBlack.6bde579e.png";